import { useCallback } from 'react';
import { chartApi } from '../../../redux/config/chart-data';
import { useAppDispatch } from '../../../redux/hooks';

export default function useInvalidateChartResponse(widgetId: number | string) {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    dispatch(chartApi.util.invalidateTags([{ type: 'ChartResponse', id: widgetId } as const]));
  }, [widgetId, dispatch]);
}
